<template>
  <div>
    <input v-model.lazy="amount" v-money="money" class="form-control" placeholder="Rp.50.000,00" required :name="inputName" />
    <input type="hidden" name="bid_amount" :value="originalAmount">
  </div>
</template>

<script>
import { VMoney, Money } from 'v-money'

export default {
  components: {
    Money,
  },
  directives: { money: VMoney },
  props: {
    inputName: {
      type: String,
      required: true
    },
    cookies:{
      type: String,
      default: ''
    }
  },
  data() {
    return {
      amount: 0,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'Rp ',
        suffix: '',
        precision: 0,
        masked: true,
      }
    }
  },
  computed: {
    originalAmount(){
      if (typeof this.amount != 'string'){
        return this.amount
      }
      let unmasked = this.amount.replace('Rp ', '')
      unmasked = unmasked.replace(/\,/g, '')
      unmasked = unmasked.replace(/\./g, '')
      return parseInt(unmasked.trim())
    },
  },
  mounted(){
    if(this.cookies != ''){
      this.amount = this.cookies
    }
  }
}
</script>